import React from 'react';
import css from './BenefitsSection.module.css';
import featureImg from '../../../../assets/EarlyOpportunitySectionImage.png';
import weeksIcon from '../../../../assets/Weeks-early-access-logo.svg';
import firstReachIcon from '../../../../assets/First-to-reach-customers-logo.svg';
import verifiedIcon from '../../../../assets/Real-verified-projects-logo.svg';
import foundIcon from '../../../../assets/Found-real-customers-logo.svg';
import eliminateIcon from '../../../../assets/Eliminate-manual-logo.svg';

const benefits = [
  {
    icon: weeksIcon,
    title: 'Up to 8 Weeks Earlier Access',
    desc: 'See projects before they reach open competition',
  },
  {
    icon: firstReachIcon,
    title: 'Be First to Reach the Customer',
    desc: 'Start conversations before competitors',
  },
  {
    icon: verifiedIcon,
    title: 'Real, Verified Project Opportunities',
    desc: 'Live planning data—not recycled leads',
  },
  {
    icon: foundIcon,
    title: 'Get Found by Active Customers',
    desc: 'Attract inbound enquiries through your profile',
  },
  {
    icon: eliminateIcon,
    title: 'Eliminate Manual Prospecting',
    desc: 'Save hours every week with automated discovery',
  },
];

const BenefitsSection = () => {
  return (
    <section className={css.section}>
      <div className={css.mockupWrapper}>
        <img src={featureImg} alt="LeadFlow Dashboard" className={css.featureImg} />
      </div>

      <div className={css.inner}>
        <h2 className={css.heading}>Turn early opportunities into real conversations</h2>
        <p className={css.subheading}>Win work before your competitors even see the project</p>

        <div className={css.grid}>
          {benefits.slice(0, 3).map((b, i) => (
            <div key={i} className={css.card}>
              <img src={b.icon} alt={b.title} className={css.icon} />
              <h3 className={css.cardTitle}>{b.title}</h3>
              <p className={css.cardDesc}>{b.desc}</p>
            </div>
          ))}
        </div>

        <div className={css.gridBottom}>
          {benefits.slice(3).map((b, i) => (
            <div key={i} className={css.card}>
              <img src={b.icon} alt={b.title} className={css.icon} />
              <h3 className={css.cardTitle}>{b.title}</h3>
              <p className={css.cardDesc}>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
